export const durationOptions = [
	{ id: '15', value: '15', label: '15 minutes' },
	{ id: '30', value: '30', label: '30 minutes' },
	{ id: '45', value: '45', label: '45 minutes' },
	{ id: '60', value: '60', label: '60 minutes' },
	{ id: '75', value: '75', label: '75 minutes' },
	{ id: '90', value: '90', label: '90 minutes' },
	{ id: '105', value: '105', label: '105 minutes' },
	{ id: '120', value: '120', label: '120 minutes' },
]
export enum FIELD_NAMES {
	DURATION = 'duration',
	PROGRAM = 'program',
	SESSION = 'session',
	INTERNAL_HOST = 'internalHost',
	EMAIL = 'externalHostMail',
	IS_PROGRAM_TYPE = 'isProgramType',
	// IS_SINGLE_TYPE = 'isSingleType',
	IS_MULTI_SLOT = 'isMultiSlot',
	MEMBER_CHAT_ALLOW = 'memberChatAllow',
	MEMBER_VIDEO_ALLOW = 'memberVideoAllow',
	MEMBER_AUDIO_ALLOW = 'memberAudioAllow',
	TYPE = 'type',
	HOST_TYPE = 'hostType',
	IS_EXTERNAL_HOST = 'isExternalHost',
	TOPIC = 'topic',
	ALL_MEMBERS = 'allPatients',
	ALL_PROVIDERS = 'allProviders',
	DATE = 'date',
	START_TIME = 'startTime',
	SECOND_SLOT_START_TIME = 'secondSlotStartTime',
	THIRD_SLOT_START_TIME = 'thirdSlotStartTime',
	END_TIME = 'endTime',
	PARTNERS = 'partners',
	PROVIDERS = 'providers',
	MEMBER = 'patients',
	STATUS = 'status',
	CODE = 'code',
	DESCRIPTION = 'description',
	PRICE = 'price',
	COMPLETED = 'Completed',
	CONFERENCE_SLOTS = 'conferenceSlot',
	RECURSIVE_CONFERENCE_SLOTS = 'recursiveConferenceSlot',
	IS_DISABLED = 'isDisabled',
	IS_RECURRING = 'isRecurring',
	REOCCURRING_WEEK_DAYS = 'recurringType',
	RECURRING_TYPE = 'recurringType',
	END_DATE = 'endDate',
	DAYS_OF_WEEK = 'daysOfWeek',
	DAYS_OF_MONTH = 'daysOfMonth',
}

export enum CONFERENCE_FILTER_FIELDS {
	SEARCH = 'Search',
	SEARCH_MEMBER = 'search',
	CONFERENCE_SLOTS = 'conferenceSlot',
	STATUS = 'status',
	CONFERENCE = 'conference',
}
export enum CONFERENCE_TYPE {
	GENERAL_CONFERENCE = 'generalConference',
	PROGRAM_CONFERENCE = 'program/sessionConference',
	INTERNAL_HOST = 'internalHost',
	EXTERNAL_HOST = 'externalHost',
}
export enum CONFERENCE_DETAILS {
	START_CONFERENCE = 'Start conference now?',
	JOIN_CONFERENCE = 'Join conference now?',
	HOST_ROLE = 1,
	PARTICIPANT_ROLE = 0,
}
export const conferenceState = {
	topicSlug: '',
	userName: '',
}
export const zoomConferenceOptions = [
	// 'preview',
	'video',
	'audio',
	'settings',
	'users',
	'chat',
	'share',
	'virtualBackground',
]

export const virtualBackgroundDetails = {
	allowVirtualBackground: true,
	allowVirtualBackgroundUpload: true,
	virtualBackgrounds: [
		'https://images.unsplash.com/photo-1715490187538-30a365fa05bd?q=80&w=1945&auto=format&fit=crop',
	],
}

export const conferenceProviderDetails = {
	signature:
		'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBfa2V5IjoiaExHMUxuQmVSSVF6SnRPYmFLTGQxeGRqOEJmaWhGVmtNWVZrIiwicm9sZV90eXBlIjowLCJ0cGMiOiJHZW5lcmFsLTBhOTFlNzk0LWVjODMtNDg5MS04ZTk1LWI0Mjk3ZDY4MGI2ZSIsInZlcnNpb24iOjEsImlhdCI6MTc0NDAwNDE1NywiZXhwIjoxNzQ0MDExMzU3fQ.-nlan7yUGw-_MpQnhi19qRi7VPXbsxYiiUDvTunIvk4',
}

export const configDetails = {
	videoSDKJWT:
		'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBfa2V5IjoiaExHMUxuQmVSSVF6SnRPYmFLTGQxeGRqOEJmaWhGVmtNWVZrIiwicm9sZV90eXBlIjoxLCJ0cGMiOiJjb25mZXJuY2UgMDcgYXByaWwtMjcyNmQ2MmMtNzU1Yy00ZWU1LTk2NzgtNzFiNjRkYWExYTliIiwidmVyc2lvbiI6MSwiaWF0IjoxNzQ0MDA3OTAzLCJleHAiOjE3NDQwMTUxMDN9.7WCxGFuOlC7yx_mhac1I0ZM43hUVEcZMcgqO00xwxAQ',
	sessionName: 'confernce 07 april-2726d62c-755c-4ee5-9678-71b64daa1a9b',
	userName: 'CareHalo West-yiq0Z9SdLkSZeRG5vqVInqFlfr33',
	features: ['video', 'audio', 'settings', 'users', 'chat', 'share'],
	options: {
		init: {},
		audio: {},
		video: {},
		share: {},
	},
	virtualBackground: {
		allowVirtualBackground: true,
		allowVirtualBackgroundUpload: true,
		virtualBackgrounds: [
			'https://images.unsplash.com/photo-1715490187538-30a365fa05bd?q=80&w=1945&auto=format&fit=crop',
		],
	},
}

export enum CONFERENCE_STATUS {
	COMPLETED = 'Completed',
	IN_PROGRESS = 'Inprogress',
	ONGOING = 'Ongoing',
	UPCOMING = 'Upcoming',
	LIVE = 'Live',
	EXPIRED = 'Expired',
	ACTIVE = 'Active',
}

export enum RECURRING_TYPES {
	DAILY = 'daily',
	WEEKLY = 'weekly',
	MONTHLY = 'monthly',
}
